// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__frame-Header--vTiMG {
  background: #090A0C;
  text-align: center;
  width: 100%;
  height: 76px;
}

.Header-module__wrap--PINMI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: var(--layout-width);
  padding-left: 44px;
  padding-right: 44px;
  margin: 0 auto;
  text-align: left;
  box-sizing: border-box;
}

.Header-module__frame-Header-Logo--dbvNa {
  display: inline-flex;
  align-items: center;
}

.Header-module__frame-Header-Logo--dbvNa a {
  text-decoration: none;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__img--JopX_ {
  padding-right: 12px;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__img--JopX_ img {
  vertical-align: middle;
}

.Header-module__frame-Header-Logo--dbvNa .Header-module__text--U1myF {
  font-size: 25px;
  font-weight: 700;
  color: #ffffff;
}

.Header-module__frame-Header-Nav--vEdkB {
  display: flex;
}

.Header-module__frame-Header-Nav--vEdkB a {
  font-size: 14px;
  font-weight: 600;
  color: #BDBDBD;
  padding-left: 21px;
  padding-right: 21px;
  text-decoration: none;
}


.Header-module__frame-Header-Nav--vEdkB a.Header-module__is-active--BdT0M {
  color: #ffffff;
}

.Header-module__actions--SQFIB {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Header-module__frame-Header-ProfileButton--U0aGh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
}

.Header-module__frame-Header-ProfileButton--U0aGh img {
  display: block;
  width: 18px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/frames/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd","sourcesContent":[".frame-Header {\n  background: #090A0C;\n  text-align: center;\n  width: 100%;\n  height: 76px;\n}\n\n.wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: var(--layout-width);\n  padding-left: 44px;\n  padding-right: 44px;\n  margin: 0 auto;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.frame-Header-Logo {\n  display: inline-flex;\n  align-items: center;\n}\n\n.frame-Header-Logo a {\n  text-decoration: none;\n}\n\n.frame-Header-Logo .img {\n  padding-right: 12px;\n}\n\n.frame-Header-Logo .img img {\n  vertical-align: middle;\n}\n\n.frame-Header-Logo .text {\n  font-size: 25px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.frame-Header-Nav {\n  display: flex;\n}\n\n.frame-Header-Nav a {\n  font-size: 14px;\n  font-weight: 600;\n  color: #BDBDBD;\n  padding-left: 21px;\n  padding-right: 21px;\n  text-decoration: none;\n}\n\n\n.frame-Header-Nav a.is-active {\n  color: #ffffff;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.frame-Header-ProfileButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #ffffff;\n  cursor: pointer;\n}\n\n.frame-Header-ProfileButton img {\n  display: block;\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame-Header": `Header-module__frame-Header--vTiMG`,
	"wrap": `Header-module__wrap--PINMI`,
	"frame-Header-Logo": `Header-module__frame-Header-Logo--dbvNa`,
	"img": `Header-module__img--JopX_`,
	"text": `Header-module__text--U1myF`,
	"frame-Header-Nav": `Header-module__frame-Header-Nav--vEdkB`,
	"is-active": `Header-module__is-active--BdT0M`,
	"actions": `Header-module__actions--SQFIB`,
	"frame-Header-ProfileButton": `Header-module__frame-Header-ProfileButton--U0aGh`
};
export default ___CSS_LOADER_EXPORT___;
